// extracted by mini-css-extract-plugin
module.exports = {"projectTechstack":"ProjectTechstack-module--projectTechstack--EwXzF","title":"ProjectTechstack-module--title--VTvEN Project-module--metaTitle--33nyT"};